import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { ObjectSchema } from 'yup'
import { schemaNumber } from 'schemas/baseSchema'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskCurrencyPositive } from 'components/atoms/inputs/maskedInput'
import { FutureOccurrenceField } from 'components/features/future/FutureOccurrenceField/FutureOccurrenceField'
import { OPTIONS_WITH_6_MONTH } from 'components/features/future/FutureRepeatInput/FutureRepeatInput'
import { schemaRecurrence } from 'schemas/futureSchema'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'

const LAYER_SLUG = 'vacation' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  value: schemaNumber,
  recurrence: schemaRecurrence,
  recurrence_count: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneVacationProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneVacation: FC<FutureLayerPaneVacationProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  const layerWidthDefaults = useMemo(() => ({
    recurrence: 'one_time',
    recurrence_count: 1,
    ...layer,
  } as typeof layer), [layer])

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layerWidthDefaults }
      slug={ LAYER_SLUG }
      name='Vacation'
      icon='travel-solid'
      type='goal'
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  const errors = useCollectLayerErrors<LayerType>()

  const completeChild = useMemo(() => (
    <h1>
      Goal Achieved
    </h1>
  ), [])

  return (
    <LayerStatus uid={ uid || null } completeContent={ completeChild } skipPartialState type='goal'>
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='Total Cost'
        name='value'
        mask={ maskCurrencyPositive }

        error={ errors.value }

        min={ 0 }
        max={ 15000 }
        step={ 50 }
      />

      <FutureOccurrenceField errors={ errors } options={ OPTIONS_WITH_6_MONTH } />
    </LayerStatus>
  )
}
